export const statuses = {
    'unreviewed' : 'Unreviewed',
    'in_progress' : 'In Progress',
    'completed' : 'Completed',
    'converted' : 'Converted',
    'rejected' : 'Rejected',
}

export const publicStatuses = {
    'in_review' : 'In Review',
    'approved' : 'Approved',
    'rejected' : 'Rejected',
    'private' : 'Private',
}
